import type {FC} from 'react';

import styled from 'styled-components';

import {View} from '../../../../uikit/View';
import {Timeslot} from '../Timeslot';

const Container = styled(View)`
  flex-flow: row wrap;
  height: 0;
`;

const EMPTY_FN = () => {};

export const FakeTimeslotsRow: FC = () => {
  return (
    <Container>
      {Array(12)
        .fill(null)
        .map((_, index) => (
          <Timeslot
            isDisabled={false}
            isHidden={true}
            isSelected={false}
            key={index}
            label="12:00 AM"
            onClick={EMPTY_FN}
          />
        ))}
    </Container>
  );
};
